import { NavLink } from 'react-router-dom';
import { formatDate, SelectItemProps } from '@ui/src';
import { LinkedClient } from '../types';

import cn from '../styles.module.css';

const formatLinkedClientsList = (
  list?: LinkedClient[],
  pspPartners?: SelectItemProps[],
): LinkedClient[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    let currentPspPartner = <div>-</div>;

    if (result.pspPartnerId) {
      currentPspPartner = (
        <NavLink
          to={`/bank-and-psp/${result.pspPartnerId}`}
          target="_blank"
          className={cn.linkedClientsPspPartnerLink}
        >
          {
            pspPartners?.find(
              (pspPartner) => pspPartner.value === result.pspPartnerId,
            )?.name
          }
        </NavLink>
      );
    }

    const render: Record<string, any> = {
      createdAt: <div>{formatDate(result?.createdAt)}</div>,
      pspPartnerId: currentPspPartner,
      active: <div>{result.active ? 'Active' : 'Inactive'}</div>,
    };

    result.render = render;

    return result;
  });

  return nextList as LinkedClient[];
};

export default formatLinkedClientsList;
